import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import { reduxForm, getFormValues, Field } from 'redux-form';
import _ from 'lodash';
import {
  touchFields
} from '../../../redux/modules/pages/Movers/localization/localization';
import {
  omniGetCommunity,
  omniLocalizeAddress
} from '../../../redux/modules/pages/Omni/omniSales/localization';
import { moveDateRangeSelector } from '../../../redux/modules/data/customer/customer';
import { isMobileSelector } from '../../../redux/modules/common/common';
import {Col, Row} from '../../../shared/packages/Grid';
import Helmet from 'react-helmet';
import MoversNav from '../../../components/Movers/Common/MoversNav/MoversNav.jsx';
import InputField from '../../../components/Common/Form/InputField.jsx';
import Feed from '../../../components/Omni/OmniSales/Feed.jsx';

class OmniSalesPage extends Component {
  componentDidMount() {
    const {omniGetCommunity} = this.props.actions;

    omniGetCommunity();
  }

  handleContinue() {
    const {
      actions,
      valid
    } = this.props;

    if (valid) {
      actions.omniLocalizeAddress();
    } else {
      actions.touchFields();
    }
  }

  render() {

    const {
      feedData,
      valid,
      handleSubmit
    } = this.props;

    const linkOutImg = `${__ASSETSPath__}img/common/icons/link-out.svg`; // eslint-disable-line no-undef

    return (
      <div className="omni-localization mp-page-container">
        <Helmet
          title="Omni Sales"
        />
        <div className="container container--omni">
          <Row>
            <Col lg={10} lgOffset={1} xs={12}>
              <form onSubmit={handleSubmit(this.handleContinue.bind(this))}>
                <Row>
                  <Col xs={12}>
                    <div className="hgroup">
                      <h1 className="x-heading1">
                        Welcome to Omni Sales
                      </h1>
                      <h2 className="x-heading2 hgroup__subheading">
                        Select continue to localize
                      </h2>
                    </div>
                  </Col>
                </Row>
                <Row className="row--movers">
                  <Col xs={6} md={3} lg={2}>
                    <Field component={InputField} name="ntId" type="ntId" placeholder="ntId" />
                  </Col>
                  <Col xs={6} md={3} lg={2}>
                    <Field component={InputField} name="csgSalesRepId" type="csgSalesRepId" placeholder="csgSalesRepId" />
                  </Col>
                  <Col xs={6} md={3} lg={2}>
                    <Field component={InputField} name="csgOperatorId" type="csgOperatorId" placeholder="csgOperatorId" />
                  </Col>
                  <Col xs={6} md={3} lg={2}>
                    <Field component={InputField} name="ddpSalesRepId" type="ddpSalesRepId" placeholder="ddpSalesRepId" />
                  </Col>
                  <Col xs={6} md={3} lg={2}>
                    <Field component={InputField} name="ddpOperatorId" type="ddpOperatorId" placeholder="ddpOperatorId" />
                  </Col>
                </Row>
                <Row className="row--movers">
                  <Col xs={12} md={6} mdOffset={6}>
                    <MoversNav
                      nextText="Continue"
                      valid={valid}
                    />
                  </Col>
                </Row>
              </form>
            </Col>
          </Row>
        </div>
        <a className="community-feed-link-out" href="//omni-feedback.aws-origin.xfinity.com" target="_blank">
          <img width="40" height="40" src={linkOutImg} />
          <p className="x-body4 community-feed-link-out-text">Community<br />Portal</p>
        </a>
        {feedData &&
          <div className="container container--omni container--omni-bottom">
            <Row>
              <Col lg={10} lgOffset={1} xs={12}>
                <Feed feedData={feedData} />
              </Col>
            </Row>
          </div>
          }
      </div>
    );
  }
}

OmniSalesPage.propTypes = {
  customer: PropTypes.object.isRequired,
  suggestions: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
  valid: PropTypes.bool.isRequired,
  dateRange: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  formValues: PropTypes.object,
  feedData: PropTypes.object
};

function mapStateToProps(state) {
  const formValues = getFormValues('omniLocalize')(state) || {streetAddress: ''};

  return {
    customer: state.customer.customer,
    feedData: _.get(state, 'omniSales.communityData'),
    dateRange: moveDateRangeSelector(state),
    isMobile: isMobileSelector(state),
    suggestions: _.get(state, 'suggestions.suggestions.localizeSuggestions', []),
    formValues: formValues,
    initialValues: {
      streetAddress: _.get(state, 'customer.customer.moveToAddress.streetAddress', ''),
      unitNumber: _.get(state, 'customer.customer.moveToAddress.unitNumber', ''),
      zipCode: _.get(state, 'customer.customer.moveToAddress.zipCode', '')
    }
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      omniGetCommunity,
      omniLocalizeAddress,
      touchFields
    }, dispatch)
  };
}

const OmniSalesPageForm = reduxForm({
  form:'omniLocalize',
  enableReinitialize: true
})(OmniSalesPage);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OmniSalesPageForm);



/** WEBPACK FOOTER **
 ** ./client/containers/Omni/OmniSales/OmniSalesPage.jsx
 **/